module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Back"},"ru":{"cancel":"Назад"},"ua":{"cancel":"Назад"}}')
  delete Component.options._Ctor
}
